<template>
  <vx-card :class="cardClass">
    <div class="flex mb-4">
      <!-- perPage 도 prop 이다. page 와 같은 이유로 :value 단방향으로 바인딩한다. -->
      <vs-select v-if="perPage" :value="perPage" autocomplete class="mr-4" style="width: 110px" @input="onChangePerPage">
        <vs-select-item v-for="v in [10, 20, 30, 50]" :text="`${v}개씩 보기`" :value="v" />
      </vs-select>
    </div>
    <vs-table class="pb-wide" color="success" style="min-width: 100%; width: auto" ref="table" :sst="true" :data="parsedListForTable" no-data-text="" @sort="onClickSort" @selected="onClickDetail">
      <!--헤더-->
      <template slot="thead">
        <vs-th v-if="multiSelect" :class="['px-1', 'sticky-column', lastStickyColumnInfo.type === 'multiSelect' ? 'last-sticky-column' : '']" :style="{ width: '35px', minWidth: '35px', maxWidth: '35px', position: 'sticky', left: stickyPositions.multiSelect, zIndex: 10 }">
          <div class="w-full flex justify-center items-center"><vs-checkbox class="p-0 m-0" :value="isAll" @input="onClickAllCheck"/></div>
        </vs-th>
        <vs-th v-if="baseColumn" sort-key="No" :class="['sticky-column', lastStickyColumnInfo.type === 'baseColumn' ? 'last-sticky-column' : '']" :style="{ width: '60px', minWidth: '60px', textAlign: 'center', position: 'sticky', left: stickyPositions.baseColumn, zIndex: 10 }"><span class="w-full text-center">No.</span></vs-th>
        <vs-th v-for="(head, index) in heads" :key="`table_header_${head.name}`"
               :class="[
                 head.class,
                 head.pivot === true ? 'sticky-column' : '',
                 (head.pivot === true && lastStickyColumnInfo.type === 'pivot' && lastStickyColumnInfo.index === index) ? 'last-sticky-column' : ''
               ]"
               :style="{
                 textAlign: 'center',
                 ...(head.pivot === true ? {
                   // 고정 컬럼: 고정 너비 사용
                   width: (head.style && head.style.width) || (head.style && head.style.minWidth) || '200px',
                   minWidth: (head.style && head.style.width) || (head.style && head.style.minWidth) || '200px',
                   maxWidth: (head.style && head.style.width) || (head.style && head.style.minWidth) || '200px',
                   position: 'sticky',
                   left: stickyPositions[`head_${index}`],
                   zIndex: 10
                 } : {
                   // 일반 컬럼: 남은 공간을 퍼센트로 분할
                   width: `${normalColumnsWidthPercent / (heads.length - heads.filter(h => h.pivot === true).length)}%`,
                   minWidth: '100px'
                 }),
                 ...head.style
               }"
               :sort-key="head.keyName">
          <span class="w-full" v-html="head.name"></span>
        </vs-th>
        <vs-th v-if="baseColumn && useFinishLater" sort-key="문서상태" style="min-width: 100px"><span class="w-full text-center">문서상태</span></vs-th>
        <vs-th v-if="baseColumn && boardSlug && approval" sort-key="결재상태" style="min-width: 100px; width: 100px; text-align: center"><span class="w-full text-center">결재상태</span></vs-th>
        <vs-th v-if="baseColumn && moveProject" style="min-width: 200px; width: 200px"><span class="w-full text-center">보기</span></vs-th>
      </template>

      <!--본문영역-->
      <template slot-scope="{ data }">
        <template v-if="loading">
          <tr>
            <td colspan="100">
              <div class="w-full p-5 flex items-center justify-center" style="min-height: 100px">
                <feather-icon icon="LoaderIcon" class="mr-2 rotate-icon" />
                데이터를 불러오는 중입니다.
              </div>
            </td>
          </tr>
        </template>
        <template v-else-if="!data || data.length < 1">
          <tr>
            <td colspan="100">
              <div class="w-full p-5 flex items-center justify-center" style="min-height: 100px">
                <feather-icon icon="AlertTriangleIcon" class="mr-2" />
                표시할 데이터가 없습니다.
              </div>
            </td>
          </tr>
        </template>

        <template v-else>
          <vs-tr v-for="(tr, ri) in data" :data="tr" :key="ri" :style="{ 'fontSize' : fontSize || '', ...(tr.style || {})  }" :class="[
            selectList && tr.raw && selectList.findIndex((item) => item.id === tr.raw.post_id || item.id === tr.raw.id) >= 0 ? 'selectItem' : '',
            tr.class || ''
          ]">

            <vs-td v-if="multiSelect" :class="['px-1', 'sticky-column', lastStickyColumnInfo.type === 'multiSelect' ? 'last-sticky-column' : '']" :style="{ width: '35px', minWidth: '35px', maxWidth: '35px', position: 'sticky', left: stickyPositions.multiSelect, zIndex: 10 }">
              {{tr.isChecked}}
              <div class="w-full flex justify-center items-center"><vs-checkbox :value="multiSelectList && tr.raw && multiSelectList.findIndex((item) => item.postId === tr.postId) >= 0" class="p-0 m-0"/></div>
            </vs-td>
            <vs-td v-if="baseColumn" :class="['text-center', 'sticky-column', lastStickyColumnInfo.type === 'baseColumn' ? 'last-sticky-column' : '']" :style="{ position: 'sticky', left: stickyPositions.baseColumn, zIndex: 10 }">
              {{ tr["No"] }}
            </vs-td>

            <vs-td v-for="(head, ci) in heads" :key="`table_list_${ri}_${ci}_${head.name}`"
                   :class="[
                     'text-center',
                     head.pivot === true ? 'sticky-column' : '',
                     (head.pivot === true && lastStickyColumnInfo.type === 'pivot' && lastStickyColumnInfo.index === ci) ? 'last-sticky-column' : ''
                   ]"
                   :style="{
                     ...(head.pivot === true ? {
                       // 고정 컬럼: 고정 너비 사용
                       width: (head.style && head.style.width) || (head.style && head.style.minWidth) || '200px',
                       minWidth: (head.style && head.style.width) || (head.style && head.style.minWidth) || '200px',
                       maxWidth: (head.style && head.style.width) || (head.style && head.style.minWidth) || '200px',
                       position: 'sticky',
                       left: stickyPositions[`head_${ci}`],
                       zIndex: 10
                     } : {
                       // 일반 컬럼: 남은 공간을 퍼센트로 분할
                       width: `${normalColumnsWidthPercent / (heads.length - heads.filter(h => h.pivot === true).length)}%`,
                       minWidth: '100px'
                     }),
                     ...head.style
                   }">
              <div v-if="typeof tr[head.name] === 'object'">
                <slot name="typeObj" :trData="tr[head.name]" :head="head" :ri="ri" :ci="ci"></slot>
              </div>
              <div v-else
                   :style="getTextDisplayStyle(head)"
                   :title="(head.textDisplay === 'wrap' || head.textDisplay === 'multiline') ? '' : (tr[head.name] ? tr[head.name] : '　')">
                {{ tr[head.name] ? tr[head.name] : "　" }}
              </div>
            </vs-td>

            <vs-td v-if="baseColumn && useFinishLater" class="text-center">{{ tr["문서상태"] }}</vs-td>
            <vs-td v-if="baseColumn && boardSlug && approval" class="text-center">
              {{ tr["결재상태"] }}
            </vs-td>

            <vs-td v-if="baseColumn && moveProject" class="text-center" @click.stop>
              <div class="flex justify-center" @click.stop>
                <vs-button type="border" icon="open_in_new" class="mr-1" @click.stop="() => onClickDetail(tr, '_blank')"></vs-button>
                <vs-button type="border" @click.stop="() => onClickDetail(tr, 'self')">{{ $t("button.바로가기") }} </vs-button>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </template>
    </vs-table>

    <!--페이지네이션-->
    <div class="vs-con-table" v-if="selectTab === 0">
      <div class="con-pagination-table vs-table--pagination">
        <!-- page 는 prop 이므로 v-model 을 쓰면 자식이 prop 을 직접 변경한다.
             현재 페이지는 부모(TableListPage)가 onChangePage 로 갱신해 :page 로 다시 내려주므로
             :value 단방향으로 충분하다. v-model 은 한 번의 클릭에 prop 변경과 onChangePage 를
             동시에 일으켜 router.push 가 중복되는 원인이 된다. -->
        <k-pagination :total="lastPage" :max-items="5" :value="page" @input="onChangePage"></k-pagination>
      </div>
    </div>
  </vx-card>
</template>

<script>
import KPagination from "@/components/kPagination/kPagination";

export default {
  name: "ThemeOrigin",
  components: {
    KPagination,
  },
  props: {
    cardClass: {
      type: String,
      default: "",
    },
    multiSelect: {
      type: Boolean,
      default: false,
    },
    multiSelectList: {
      type: Array,
      default: () => [],
    },
    baseColumn: {
      type: Boolean,
      default: true,
    },
    heads: {
      type: Array,
      required: true,
    },
    parsedListForTable: {
      type: Array,
      required: true,
    },
    approval: {
      type: Boolean,
      default: false,
    },
    useFinishLater: {
      type: Boolean,
      default: false,
    },
    boardSlug: {
      type: String,
      default: "",
    },
    moveProject: {
      type: Boolean,
      default: false,
    },
    selectList: {
      type: Array,
      default: () => [],
    },
    fontSize: {
      type: String,
      default: "",
    },
    selectTab: {
      type: Number,
      default: 0,
    },
    lastPage: {
      type: Number,
      required: true,
    },
    page: {
      type: Number,
      required: true,
    },
    perPage: {
      type: Number,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isAll() {
      // parsedListForTable 가 multiSelectList 에 모두 포함되어 있는지 확인
      return this.parsedListForTable.length > 0 && this.parsedListForTable.every((item) => this.multiSelectList.findIndex((v) => v.postId === item.postId) >= 0);
    },
    // pivot === true인 컬럼들의 left 값을 픽셀 기반으로 계산
    stickyPositions() {
      let position = 0;
      const positions = {};

      // multiSelect 컬럼
      if (this.multiSelect) {
        positions.multiSelect = `${position}px`;
        position += 35;
      }

      // baseColumn No. 컬럼
      if (this.baseColumn) {
        positions.baseColumn = `${position}px`;
        position += 60;
      }

      // heads 배열의 pivot === true 컬럼들
      this.heads.forEach((head, index) => {
        if (head.pivot === true) {
          positions[`head_${index}`] = `${position}px`;

          // 고정 컬럼은 고정 너비 사용 (기본 200px 또는 설정된 픽셀 값)
          let columnWidth = 200; // 기본값 (사용자 요구사항에 맞춰 증가)
          if (head.style && head.style.width) {
            const width = head.style.width;
            if (typeof width === 'string' && width.includes('px')) {
              columnWidth = parseInt(width);
            } else if (typeof width === 'number') {
              columnWidth = width;
            }
          } else if (head.style && head.style.minWidth) {
            const minWidth = head.style.minWidth;
            if (typeof minWidth === 'string' && minWidth.includes('px')) {
              columnWidth = parseInt(minWidth);
            } else if (typeof minWidth === 'number') {
              columnWidth = minWidth;
            }
          }

          position += columnWidth;
        }
      });

      return positions;
    },
    // pivot 컬럼이 아닌 일반 컬럼들의 총 너비 퍼센트 계산
    normalColumnsWidthPercent() {
      const pivotColumnCount = this.heads.filter(head => head.pivot === true).length;
      const remainingColumns = this.heads.length - pivotColumnCount;
      return remainingColumns > 0 ? (this.approval ? 90 : 96) / this.heads.length * remainingColumns : 0;
    },
    // 마지막 고정 컬럼 정보 (multiSelect, baseColumn, pivot 컬럼 모두 포함)
    lastStickyColumnInfo() {
      let lastType = null;
      let lastIndex = -1;

      // pivot 컬럼 중 마지막 찾기
      for (let i = this.heads.length - 1; i >= 0; i--) {
        if (this.heads[i].pivot === true) {
          lastType = 'pivot';
          lastIndex = i;
          break;
        }
      }

      // baseColumn이 있고 pivot 컬럼이 없으면 baseColumn이 마지막
      if (lastType === null && this.baseColumn) {
        lastType = 'baseColumn';
      }

      // multiSelect가 있고 다른 고정 컬럼이 없으면 multiSelect가 마지막
      if (lastType === null && this.multiSelect) {
        lastType = 'multiSelect';
      }

      return { type: lastType, index: lastIndex };
    },
    // 텍스트 표시 스타일 생성
    getTextDisplayStyle() {
      return (head) => {
        const options = head.textDisplay || 'ellipsis'; // 기본값: ellipsis
        const maxLines = head.maxLines || 1;
        const wordBreak = head.wordBreak || 'normal';

        switch (options) {
          case 'wrap':
            // 전체 텍스트를 줄바꿈으로 표시
            return {
              whiteSpace: 'normal',
              wordBreak: wordBreak,
              overflow: 'visible',
              textOverflow: 'clip'
            };

          case 'multiline':
            // 지정된 줄 수까지 표시하고 나머지는 ... 처리
            return {
              display: '-webkit-box',
              WebkitBoxOrient: 'vertical',
              WebkitLineClamp: maxLines,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'normal',
              wordBreak: wordBreak
            };

          case 'clip':
            // 잘라내기 (... 없이)
            return {
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'clip',
              wordBreak: wordBreak
            };

          case 'ellipsis':
          default:
            // 기본 말줄임 (한 줄)
            return {
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              wordBreak: wordBreak
            };
        }
      };
    },
  },
  methods: {
    onClickAllCheck() {
      this.$emit("allCheck", this.isAll);
    },
    onClickSort(sortKey, orderBy) {
      this.$emit("sort", sortKey, orderBy);
    },
    onClickDetail(item, target = "self") {
      this.$emit("selected", item, target);
    },
    onChangePage(page) {
      this.$emit("change", page);
    },
    onChangePerPage(perPage) {
      this.$emit("changePerPage", perPage);
    },
  },
};
</script>
<style lang="scss" scoped>
.rotate-icon {
  animation: rotate 2s linear infinite;
}

// 고정 컬럼 스타일
.sticky-column {
  background-color: white !important;
  border-right: none !important; // 세로 라인 제거

  // 마지막 고정 컬럼에만 그림자 효과 (box-shadow 사용)
  &.last-sticky-column {
    box-shadow: 2px 0 3px rgba(0, 0, 0, 0.05);
  }
}

// vs-table에 overflow 설정
:deep(.vs-table) {
  overflow-x: auto;

  table {
    border-collapse: collapse; // 테이블 border 간격 제거
    border-spacing: 0;
  }

  .vs-table--content {
    min-width: max-content;
  }

  // 고정 컬럼 기본 스타일 (텍스트 표시는 동적으로 설정)
  .sticky-column {
    position: relative;
  }

  // 동적 텍스트 표시를 위한 셀 높이 조정
  td, th {
    vertical-align: top; // 셀 내용을 상단 정렬
    padding: 8px; // 적절한 패딩
    height: auto; // 자동 높이 조정
  }
}
</style>
